"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionTypes = void 0;
const enums_1 = require("../../../../global/enums");
const enums_2 = require("../../../enums");
exports.TransactionTypes = {
    [enums_1.Language.ENGLISH]: {
        [enums_2.TransactionTypes.SALE]: 'Sale',
        [enums_2.TransactionTypes.REFUND]: 'Refund',
    },
    [enums_1.Language.FRENCH]: {
        [enums_2.TransactionTypes.SALE]: 'Achat',
        [enums_2.TransactionTypes.REFUND]: "Remise d'Achat",
    },
};
//# sourceMappingURL=TransactionTypes.js.map